import { render, staticRenderFns } from "./BLayoutExpansionTable.vue?vue&type=template&id=ce25b208&"
import script from "./BLayoutExpansionTable.vue?vue&type=script&lang=js&"
export * from "./BLayoutExpansionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports